import Lara from '@primeng/themes/lara';
import { ThemeType } from 'primeng/config';

export const Theme2care4Preset: ThemeType = {
  preset: Lara,
  options: {
    darkModeSelector: '.app-dark',
    cssLayer: {
      name: 'primeng',
      order: 'primeng, theme-2care4',
    },
  },
};
